import i18n from "@/plugins/vue-i18n";

const Login = () => import(/* webpackChunkName: "auth" */ "@/views/agent/auth/login");

const login = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: i18n.t("title.auth.login"),
    },
  },
];

export default login;
